import { CreateDossierFromGardienFourriereDto } from 'lib_api/lib/api/gen';

import { fourriereFormValuesToRequestDto } from './FicheFourriereForm/utils';
import { infractionFormValuesToRequestDto } from './FicheInfractionForm/utils';
import { ficheJudiciaireFormValuesToRequestDto } from './FicheJudiciaireForm/utils';
import { vehiculeFormValuesToRequestDto } from './FicheVehiculeForm/utils';
import { FicheDescriptiveFormValues, VehiculeVerouillage } from './types';

export function ficheDescriptiveFormValuesToRequest(
  ficheDescriptive: FicheDescriptiveFormValues,
  idCorrelationFourriere: string,
): CreateDossierFromGardienFourriereDto {
  return {
    ficheVehiculeRequest: vehiculeFormValuesToRequestDto(
      ficheDescriptive.ficheVehicule,
    ),
    ficheFourriereRequest: fourriereFormValuesToRequestDto(
      ficheDescriptive.ficheFourriere,
      idCorrelationFourriere,
    ),
    ficheInfractionRequest: infractionFormValuesToRequestDto(
      ficheDescriptive.ficheInfraction,
      idCorrelationFourriere,
    ),
    ficheJudiciaireRequest: ficheJudiciaireFormValuesToRequestDto(
      ficheDescriptive.FicheJudiciaire,
    ),
  };
}

export function initialFicheDescriptiveFormValues(): FicheDescriptiveFormValues {
  return {
    ficheFourriere: {},
    ficheInfraction: {},
    FicheJudiciaire: {},
    ficheVehicule: {
      verrouillage: [
        VehiculeVerouillage.VEROUILLAGE_COFFRES,
        VehiculeVerouillage.VEROUILLAGE_PORTES,
      ],
    },
  };
}
